import React from 'react';
import App from './app/App';
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
//import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/browser";
import { Router } from "react-router-dom";
import history from "./app/history";

import { persistor, store } from './app/store'
import ScrollToTop from './app/ScrollToTop'
import ErrorBoundary from './app/ErrorBoundary'
import Loading from './custom/Loading'

//Sentry Varaible
import { ENV } from './constants/app'

Sentry.init({
  dsn           : "https://9dc7403ca82945bd998281c14d4f3e84@sentry.io/1477569",
  environment   : ENV,
  whitelistUrls : ['stage.app.porcobrar.com', 'app.porcobrar.com'],
  ignoreErrors  : ['Request failed with status code 401', 'Non-Error exception captured']

}); // END init

// SENTRY TESTING
// Sentry.init({environment: "staging", dsn: "https://344fcbaaa7aa49bfb4edb9f979c8f8e4@sentry.io/1476888"});
// Sentry.init({environment: "production" ,dsn: "https://344fcbaaa7aa49bfb4edb9f979c8f8e4@sentry.io/1476888"});
// Sentry.init({ environment: "local" ,dsn: "https://344fcbaaa7aa49bfb4edb9f979c8f8e4@sentry.io/1476888" });

render(
  <Provider store={ store }>
    <PersistGate loading={ <Loading center /> } persistor={ persistor }>
      <Router history={ history } basename='/' >
        <ScrollToTop>
          <ErrorBoundary>
            <App/>
          </ErrorBoundary>
        </ScrollToTop>
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root')

); // END render



// WEBPACK FOOTER //
// ./src/index.js